if (!customElements.get('cork-benefits')) {
  customElements.define('cork-benefits', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.detail = this.querySelector('.pcb__detail');
      this.buttons = [...this.querySelectorAll('button')];
      this.buttons.forEach(button => {
        button.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'touch') this.show(button);
        });
        button.addEventListener('focus', () => this.show(button));
        button.addEventListener('click', () => {
          this.pinned = this.pinned === button ? null : button;
          this.show(this.pinned);
        });
      });
      this.addEventListener('pointerleave', () => {
        const focused = this.buttons.includes(document.activeElement) ? document.activeElement : null;
        this.show(this.pinned || focused);
      });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) {
          this.pinned = null;
          this.show(null);
        }
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          this.pinned = null;
          this.show(null);
        }
      });
    }
    show(button) {
      this.buttons.forEach(item => item.setAttribute('aria-expanded', String(item === button)));
      const description = button ? document.getElementById(button.getAttribute('aria-describedby')) : null;
      this.detail.textContent = description ? description.textContent : '';
    }
  });
}
